<template>
    <div id="swiperWrapper" class="swiper_wrapper">
        <swiper
          v-if="localWalletList.length"
          ref="swiper"
          :space-between="16"
          centeredSlides
          :slides-per-view="localWalletList.length === 1 ? 1 : 1.5"
          loop
          loopPreventsSliding
          :speed="500"
          :pagination="{
              clickable: true,
              el: pagination
          }"
          :navigation="{
              prevEl: prev,
              nextEl: next,
          }"
          :modules="modules"
          class="wallet_slider"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
            <swiper-slide v-for="(item, i) in localWalletList" :key="i">
                <div @click="toWallet(item)" class="slider_item">
                    <div class="currency">{{item.currency_code}}</div>
                    <div class="money">{{ getCurrencySymbol(item.currency_code) }} {{ item.balance }}</div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper_bottom" v-if="localWalletList.length > 1">
            <button ref="prev" class="swiper_button">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
                    <path d="M7.125 1.75L1.875 7L7.125 12.25" stroke="#C7FF24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <div class="swiper_pagination" ref="pagination"></div>
            <button ref="next" class="swiper_button">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
                    <path d="M1.875 1.75L7.125 7L1.875 12.25" stroke="#C7FF24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import { ref, } from 'vue'  ;
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { getCurrencySymbol } from "@/utils/currency.js"

export default {
    name: "WalletList",
    components: {
        Swiper,
        SwiperSlide,
    },
    computed: {
        activeWallet() {
          return this.$store.state.currentWallet
        },
        authToken () {
            return this.$store.state.authToken
        },
        isWalletListShort() {
          return this.$store.state.walletList?.length && this.$store.state.walletList.length === 2
        },
        localWalletList ({ isWalletListShort }) {
          if (isWalletListShort) {
            return [...this.$store.state.walletList, ...this.$store.state.walletList]
          } else {
            return this.$store.state.walletList || []
          }
        }
    },
    data() {
        return {
            activeSlide: 0,
            pagination: null,
            bullets: null
        }
    },
    mounted() {    
      this.$store.dispatch('refreshWalletList')
    },

    setup() {
        const prev = ref(null);
        const next = ref(null);
        const pagination = ref(null)
        
        return {
            modules: [Pagination, Navigation],
            prev,
            next,
            pagination
        };
    },
    methods: {
        getCurrencySymbol,
        toWallet(wallet) {
          const { id } = wallet
          this.$store.commit('updateCurrentWallet', wallet);
          this.$router.push({ name: 'WalletId', params: { id } })
        },
        onSwiper() {
          if (this.isWalletListShort) {
            this.$nextTick(() => {
              const swiperWrapper = document.getElementById('swiperWrapper')
              this.bullets = swiperWrapper.querySelectorAll( '.swiper-pagination-bullet' );

              this.bullets.forEach( (bullet, index) => {
                if (index > 1) {
                  bullet.classList.add( 'hidden' );
                }
              })
            })
          }
        },
        onSlideChange(swiper) {
            const { realIndex, clickedIndex } = swiper
            if (clickedIndex === undefined) {
              // условие не работает с кликом на кошельке, для этого используется toWallet()
              this.activeSlide = realIndex;

              if (this.bullets && this.isWalletListShort && this.activeSlide > 1) {
                this.bullets[this.activeSlide - 2].classList.add('swiper-pagination-bullet-active')
              }

              const activeWallet = this.localWalletList[this.activeSlide];

              this.$store.commit('updateCurrentWallet', activeWallet);
            }
        }
    },
    watch: {
      // основной механизм выставления дефолтного состояния текущего слайда
        localWalletList: {
            handler(newVal) {
                if (newVal && newVal.length > 0 && !this.activeWallet) {
                  const defaultWallet = newVal[0];
                  // если в сторе еще не выбран активный кошелек то выставляем его по индексу 0
                  this.$store.commit('updateCurrentWallet', defaultWallet);
                } else if (this.activeWallet) {
                  // если в сторе выбран активный кошелек то врашаем слайдер к его индексу
                  const walletIndex = this.localWalletList.findIndex(wallet =>
                    wallet.id === this.activeWallet.id
                  );
                  this.$nextTick(() => {
                    const swiper = document.querySelector('.swiper').swiper
                    if (swiper && walletIndex >= 0) {
                      swiper.slideTo(walletIndex);
                    }
                  })
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss">
 .swiper-pagination-bullet {
   &.hidden {
     display: none;
   }
 }
</style>
